import $ from 'jquery';


let isRecaptchaSuccess = false;
let feedbackElement = null;
let submitButtonElement = null;

const feedbackRecaptchaCallback = function(response) {
    isRecaptchaSuccess = !!response;
    submitButtonElement[validateRequiredField(feedbackElement) ? 'removeAttr' : 'attr']('disabled', true);

    if (isRecaptchaSuccess) {
        resetError(feedbackElement, '#error-g-recaptcha-response');
    }
}


const validateRequiredField = function($popup, target = null) {
    let state = true;
    const $inputs = $popup.find('input, textarea').filter(':not([disabled])').filter('[required]');

    if (target) {
        resetError($popup, '#error-' + target.name);
    }

    if($inputs.length) {
        $inputs.each((idx, input) => {
            if (input.type === 'checkbox') {
                if (!input.checked) {
                    state = false;
                    return false;
                }
            } else {
                if(!input.value.trim()) {
                    state = false;
                    return false;
                }
            }
        })
    }

    return state && isRecaptchaSuccess;
}

const resetError = function ($popup, selector) {
    if ($popup.find(selector).is(':visible')) {
        $popup.find(selector).text('').hide();
    }
}

const resetErrors = function($popup) {
    const $inputs = $popup.find('input, textarea').filter(':not([disabled])').filter('[required]');

    if($inputs.length) {
        $inputs.each((idx, input) => {
            resetError($popup, '#error-' + input.name);
        })
    }

    resetError($popup, '#error-unknown');
}



const showErrors = function($popup, errors) {
    let found = false;
    $.each(errors, (name, messages) => {
        let element = $popup.find('#error-' + name);
        if (element) {
            element.text(messages[0]).show();
            found = true;
        }
    })
    if (!found) {
        $popup.find('#error-unknown').text('Неизвестная ошибка').show();
    }
}

const popupFeedbackHandler = function($popupFeedback) {

    feedbackElement = $popupFeedback;
    const $submitButton = $popupFeedback.find('button[type="submit"]');
    submitButtonElement = $submitButton;

    $('body').on('popup.after_close', function () {
        const recaptchaId = $popupFeedback.find('.g-recaptcha').data('recaptcha-id');
        if (recaptchaId !== undefined) {
            grecaptcha.reset(recaptchaId);
        }
    });

    $popupFeedback.on('change input', 'input, textarea', function(e) {
        $submitButton[validateRequiredField($popupFeedback, e.target) ? 'removeAttr' : 'attr']('disabled', true);
    });

    $popupFeedback.on('reset', function() {
        $submitButton[validateRequiredField($popupFeedback) ? 'removeAttr' : 'attr']('disabled', true);
        const recaptchaId = $popupFeedback.find('.g-recaptcha').data('recaptcha-id');
        if (recaptchaId !== undefined) {
            grecaptcha.reset(recaptchaId);
        }
    })

    let isBusy = false;
    $popupFeedback.find('form').on('submit', function(e) {
        const form = this;

        e.preventDefault();

        if(isBusy) {
            return;
        }

        resetErrors($popupFeedback);
        isBusy = true;

        form.classList.add('_is-busy');

        $.ajax({
            url: form.action,
            type: form.method || 'post',
            data: $(form).serialize(),
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if(Object.hasOwn(response, 'success')) {
                    $.popup.info(['Сообщение успешно отправлено.', 'Спасибо за обратную связь!'], {center: true});

                    setTimeout(() => {
                        isBusy = false;
                        form.classList.remove('_is-busy');
                        form.reset();
                    }, 600);
                }
            },
            error: function(response) {
                isBusy = false;
                form.classList.remove('_is-busy');
                const recaptchaId = $popupFeedback.find('.g-recaptcha').data('recaptcha-id');
                if (recaptchaId !== undefined) {
                    grecaptcha.reset(recaptchaId);
                }
                isRecaptchaSuccess = false;
                $submitButton[validateRequiredField($popupFeedback) ? 'removeAttr' : 'attr']('disabled', true);

                var data = JSON.parse(response.responseText);
                showErrors($popupFeedback, Object.hasOwn(data, 'errors') ? data.errors : []);
            }
        })
    });
};

export {
    popupFeedbackHandler,
    feedbackRecaptchaCallback
};
